import { Box, Button, MenuItem, Select, Typography } from '@mui/material'

import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useStyles } from '../styles'
import { useIntl } from 'react-intl'
import useTranslations from '../../../i18n/useTranslations'
import FileUploaderContacts from '../../../ui/components/FileUploaderContacts/FileUploaderContacts'
import { useState } from 'react'
import { useUserContext } from '../../../auth/UserProvider'
import { ReactComponent as AlertIcon } from '../../../assets/icons/warning-circle-fill.svg'

const FileUploadModal = ({
  openModal,
  handleAddFile,
  handleRemoveFile,
  filesToUpload,
  manifestFiles,
  centerSelected,
  setCenterSelected,
}) => {
  const classes = useStyles()
  const t = useTranslations()
  const { centres } = useUserContext()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const acceptedFileTypes = '.xlsx, .csv'
  const intl = useIntl()

  const openCSV = async () => {
    // NOTE: solución temporal. En el futuro, el PDF será alojado en un servidor
    // o será accesible vía API.
    const file = await fetch(
      process.env.PUBLIC_URL +
        '/documents/Plantilla Carga Direcciones Web.xlsx',
    )
    const blob = await file.blob()
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Carga Direcciones Plantilla.xlsx') // Cambia 'nombre_deseado.csv' al nombre deseado
    link.click()
  }

  const isDisabled = () => {
    return (
      isLoading ||
      manifestFiles?.isLoading ||
      filesToUpload?.some(element => 'error' in element) ||
      !filesToUpload?.length ||
      error
    )
  }

  const onClickImport = async () => {
    if (!centerSelected) {
      setError('agenda:center-error')
      return
    }
    await manifestFiles.mutate({
      clientCenterCode: centerSelected?.id,
      file: filesToUpload[0],
    })
  }

  return (
    <>
      <Box className={classes.column}>
        <Typography variant="h1" className={classes.title}>
          {intl.formatMessage({ id: 'action:import-contacts' })}
        </Typography>
        <Box className={classes.modalContent}>
          <Box className={classes.instructionsContent}>
            <Typography variant={'h2'} className={classes.stepsToImport}>
              {t('agenda:how-import')}
            </Typography>
            <Typography
              className={clsx(classes.secondaryText, classes.stepText)}
            >
              <span className={classes.pointStep}>{1}</span>
              {t('agenda:step-1')}
            </Typography>
            <Typography
              className={clsx(classes.secondaryText, classes.stepText)}
            >
              <span className={classes.pointStep}>{2}</span>
              <span>
                {t('agenda:step-2-1', {
                  csv: (
                    <u
                      style={{ color: 'red', cursor: 'pointer' }}
                      onClick={openCSV}
                    >
                      {t('agenda:step-2-2')}
                    </u>
                  ),
                })}
              </span>
              <Box className={classes.stepWarning}>
                <AlertIcon className={classes.stepWarningIcon} />
                <span>
                  {t('agenda:step-2-3', {
                    strong: text => (
                      <span>
                        <b>{text}</b>
                      </span>
                    ),
                  })}
                </span>
              </Box>
            </Typography>
            <Typography
              className={clsx(classes.secondaryText, classes.stepText)}
            >
              <span className={classes.pointStep}>{3}</span>
              {t('agenda:step-3')}
            </Typography>
            <Typography
              className={clsx(classes.secondaryText, classes.stepText)}
            >
              <span className={classes.pointStep}>{4}</span>
              {t('agenda:step-4')}
            </Typography>
          </Box>
          <Box className={classes.uploaderContent}>
            <Select
              label={t('agenda:select-center')}
              className={classes.centerSelect}
              value={centerSelected}
              error={error}
              onChange={event => {
                setError(null)
                setCenterSelected(event.target.value)
              }}
            >
              {centres.map(e => {
                return (
                  <MenuItem
                    key={e}
                    value={e}
                    disabled={e?.status !== 'ACTIVE'}
                    className={classes.menuItem}
                  >
                    {`${e?.id} | ${e?.name}`}
                  </MenuItem>
                )
              })}
              <MenuItem value={null} disabled>
                <em>{t('agenda:center-to-import')}</em>
              </MenuItem>
            </Select>
            <FileUploaderContacts
              onAdd={handleAddFile}
              onDelete={handleRemoveFile}
              onLoad={setIsLoading}
              acceptFiles={acceptedFileTypes}
              initialFiles={filesToUpload}
              maxFiles={1}
              height={300}
              error={error}
            />
          </Box>
        </Box>
        <Box className={classes.buttonsGroup}>
          <Button
            variant="outlined"
            className={classes.cancelButton}
            size={'small'}
            onClick={() => openModal(false)}
          >
            {t('action:cancel')}
          </Button>
          <Button
            size={'small'}
            onClick={() => onClickImport()}
            disabled={isDisabled()}
          >
            {t('action:import-contacts')}
          </Button>
        </Box>
      </Box>
    </>
  )
}

FileUploadModal.propTypes = {
  openModal: PropTypes.func,
  handleAddFile: PropTypes.func,
  handleRemoveFile: PropTypes.func,
  filesToUpload: PropTypes.array,
  manifestFiles: PropTypes.object,
  centerSelected: PropTypes.object,
  setCenterSelected: PropTypes.func,
}

export default FileUploadModal
